import { TextTooltip } from '@components'
import React from 'react'
import { FaQuestionCircle } from 'react-icons/fa'
import styled from 'styled-components'
import { AskLuca, AskLucaProps } from './AskLuca'
import { WHEN_NARROW } from '../../layout'

interface Props {
  title?: string
  tooltip?: string
  ask?: AskLucaProps
  headerMeta?: React.ReactNode
  bare?: boolean
  className?: string
  children: React.ReactNode
}

export const Card = React.forwardRef<HTMLDivElement, Props>(function Card(
  { title, tooltip, ask, headerMeta, bare = false, className, children },
  ref
) {
  return (
    <CardSurface ref={ref} className={className}>
      {!bare && (
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {tooltip && (
            <TextTooltip tooltip={tooltip} placement="bottom">
              <HelpIcon />
            </TextTooltip>
          )}
          <HeaderSpacer />
          {headerMeta}
          {ask && <AskLuca {...ask} />}
        </CardHeader>
      )}
      {children}
    </CardSurface>
  )
})

export const CardSurface = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  box-shadow: ${({ theme }) => theme.shadow.soft};
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding: ${({ theme }) => theme.spacing.lg}rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralGray};

  ${WHEN_NARROW} {
    padding: ${({ theme }) => theme.spacing.md}rem;
  }
`

export const CardTitle = styled.h3`
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  white-space: nowrap;
`

export const CardHeaderMeta = styled.span`
  ${WHEN_NARROW} {
    display: none;
  }

  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.dashboard.textSubtle};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`

export const HeaderSpacer = styled.div.attrs({ ['aria-hidden']: true })`
  flex: 1;
`

const HelpIcon = styled(FaQuestionCircle)`
  display: block;
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: ${({ theme }) => theme.fontSize.px14}rem;
  cursor: help;
`
